<!--首頁 home-->
<ng-container *ngIf="showAnimation; else home">
  <div class="home-container home-landing-content">
    <div class="home-landing-text">
      <div class="home-landing-text-first">
        <p>5,000+</p>
        <p>智慧演算、專業分析</p>
      </div>
      <div class="home-landing-text-last">
        <p>個人化精準數據</p>
        <p>每個環節都為您量身設計</p>
      </div>
    </div>
    <img
      priority
      class="home-landing-img"
      ngSrc="/assets/img/img-landing.png"
      alt="Loading Animation"
      height="1506"
      width="2460"
    />
    <img
      priority
      class="home-landing-img-m"
      ngSrc="/assets/img/img-landing-m.jpg"
      alt="Loading Animation"
      height="1624"
      width="750"
    />
  </div>
</ng-container>

<ng-template #home>
  <div class="home-container" [class.active]="showTitleBlockAnimation">
    <ng-container
      *ngIf="translateService.currentLang === LANGS.ZH_TW; else enTemplate"
    >
      <!-- 健檢選擇頁面 -->
      <div class="selection-container">
          <!-- 主要內容區域 -->
          <div class="selection-content">
              <!-- 左側標題區域 -->
              <div class="selection-left">
                  <div class="selection-title-block">
                      <h1 class="selection-title">{{ 'new-home-page.selection-title' | translate }}</h1>
                      <h1 class="selection-title">{{ 'new-home-page.selection-subtitle' | translate }}</h1>
                      <p class="selection-subtitle">{{ 'new-home-page.selection-description' | translate }}</p>
                      <p class="selection-description">{{ 'new-home-page.selection-description-2' | translate }}</p>
                  </div>
              </div>

              <!-- 右側卡片區域 -->
              <div class="selection-right">
                  <!-- 企業預約卡片 -->
                  <div class="selection-card enterprise">
                      <div class="selection-card-header">
                          <h2>{{ 'new-home-page.company-card-title' | translate }}</h2>
                      </div>
                      <div class="selection-card-content enterprise-content">
                        <div>
                        <img src="assets/img/building-2.png" alt="" width="24" height="24"/>
                          <h3>{{ 'new-home-page.company-card-subtitle' | translate }}<br/>
                            {{ 'new-home-page.company-card-subtitle-2' | translate }}
                          </h3>
                          <p>{{ 'new-home-page.company-card-description' | translate }}</p>
                          </div>
                          <div class="selection-card-buttons">
                            <input 
                              type="text" 
                              class="selection-card-input"
                              [class.input-error]="hasError"
                              [formControl]="enterpriseCodeControl"
                              appCompanyCodeOnly
                              placeholder="請輸入企業代碼"
                              (keydown.enter)="handleEnterpriseClick()"
                              maxlength="10"
                              (input)="onInputChange($event)"
                            />
                            <button mat-button  [disabled]="isButtonDisabled" class="btn-fill-primary btn-size-m" (click)="handleEnterpriseClick()">
                              {{ 'new-home-page.company-card-button' | translate }}
                            </button>
                          </div>
                      </div>
                  </div>

                  <!-- 個人預約卡片 -->
                  <div class="selection-card personal">
                      <div class="selection-card-header">
                          <h2>{{ 'new-home-page.personal-card-title' | translate }}</h2>
                      </div>
                      <div class="selection-card-box">
                        <button mat-button class="selection-card-content-item" (click)="handlePersonalClick()">
                          <img src="assets/img/ai-upscale-spark--magnifier-zoom-view-find-search-ai.png" alt="" width="24" height="24" />
                          <h3><span class="personal-highlight">{{ 'new-home-page.personal-card-special-subtitle' | translate }}</span>
                            {{ 'new-home-page.personal-card-subtitle-2' | translate }}
                            <br/>
                            {{ 'new-home-page.personal-card-subtitle-3' | translate }}
                          </h3>
                          <p>{{ 'new-home-page.personal-card-description' | translate }}</p>
                          <div class="home-card-btn-personal">
                            <img
                              width="24"
                              height="24"
                              ngSrc="/assets/img/i-arrow-secondary.svg"
                              alt=""
                            />
                          </div>
                        </button>
                          
                      <button mat-button class="selection-feature" (click)="handleQuickReserveClick()">
                        <img src="assets/img/icon.png" alt="" width="32" height="32" />
                        <h3><span class="personal-highlight-2">{{ 'new-home-page.personal-card-special-subtitle-2' | translate }}</span>
                          {{ 'new-home-page.personal-card-subtitle-2' | translate }}
                        <br/>
                        {{ 'new-home-page.personal-card-subtitle-4' | translate }}
                        </h3>
                        <p>{{ 'new-home-page.personal-card-description-2' | translate }}</p>
                        <div class="home-card-btn-personal">
                          <img
                            width="24"
                            height="24"
                            ngSrc="/assets/img/i-arrow-secondary.svg"
                            alt=""
                          />
                        </div>
                      </button>
                      </div>
                        
                  </div>
              </div>
          </div>
          
          <!-- 15年經驗區塊 - 移到 home-container 外面 -->
          <div class="experience-section">
            <div class="experience-content">
              <div class="experience-text">
                <h1 class="experience-title">{{ 'new-home-page.experience-title' | translate }}</h1>
                <h1 class="experience-title">{{ 'new-home-page.experience-title-2' | translate }}</h1>
                <p class="experience-description">{{ 'new-home-page.experience-description' | translate }}</p>
                <p class="experience-description">{{ 'new-home-page.experience-description-2' | translate }}</p>
                <p class="experience-description">{{ 'new-home-page.experience-description-3' | translate }}</p>
              </div>
            </div>
          </div>

          <!-- 三大特色區塊 -->
          <div class="features-section">
            <div class="features-container">
              <!-- 特色1: AI協助分析 -->
              <div class="feature-card">
                <div class="feature-icon">
                  <img src="assets/img/Group 2.png" alt="AI協助分析" width="150" height="107.27" />
                </div>
                <h3 class="feature-title">{{ 'new-home-page.feature-title' | translate }}</h3>
                <h4 class="feature-subtitle">{{ 'new-home-page.feature-subtitle' | translate }}</h4>
                <p class="feature-description">{{ 'new-home-page.feature-description' | translate }}</p>
              </div>

              <!-- 特色2: 不多做只做真的需要的 -->
              <div class="feature-card">
                <div class="feature-icon">
                  <img src="assets/img/Group 3.png" alt="精準檢查" width="145.53" height="111.64" />
                </div>
                <h3 class="feature-title">{{ 'new-home-page.feature-title-2' | translate }}</h3>
                <h4 class="feature-subtitle">{{ 'new-home-page.feature-subtitle-2' | translate }}</h4>
                <p class="feature-description">{{ 'new-home-page.feature-description-2' | translate }}</p>
                <p class="feature-description">{{ 'new-home-page.feature-description-2-2' | translate }}</p>
              </div>

              <!-- 特色3: 預約健檢很簡單 -->
              <div class="feature-card">
                <div class="feature-icon">
                  <img src="assets/img/Group 4.png" alt="簡單預約" width="167.94" height="121.1" />
                </div>
                <h3 class="feature-title">{{ 'new-home-page.feature-title-3' | translate }}</h3>
                <h4 class="feature-subtitle">{{ 'new-home-page.feature-subtitle-3' | translate }}</h4>
                <p class="feature-description">{{ 'new-home-page.feature-description-3' | translate }}</p>
                <p class="feature-description">{{ 'new-home-page.feature-description-3-2' | translate }}</p>
              </div>
            </div>
          </div>

          <!-- 回到頂部按鈕 -->
          <div class="back-to-top">
            <button mat-button (click)="scrollToTop()" [class.clicked]="isBackToTopClicked">
              <img src="assets/img/Icon-Wrapper.png" alt="回到頂部" width="18" height="18" />
              {{ 'new-home-page.back-to-top' | translate }}
            </button>
          </div>

          <!-- 頁尾 -->
          <div class="footer">
            <p>{{ 'new-home-page.footer' | translate }}</p>
          </div>
          
      </div>
    </ng-container>
    <ng-template #enTemplate>
      <!-- en 區域 -->
      <h3 class="home-en-block">
        For English assistance, please call our dedicated hotline: 02-412-8006.
      </h3>
      <p class="version-text">V2.5.3</p>
    </ng-template>
  </div>
</ng-template>
